import React, { Component } from 'react'
import { Chatbot } from '../../lib/ChatbotLib';
import { Workflow } from '../../lib/WorkflowLib';
import { Tab, Container } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import WorkflowDetails from './WorkflowDetails';
import Statuses from './Statuses';
import { Status } from '../../lib/StatusLib';
import { API_HOST } from '../../utils/Constants';
import BreadCrumbs from '../BreadCrumbs';
import { CLoader } from '../../utils/CLoader';

//please fix this component to be able to pass workflowObj and statuses to WorkflowDetails component

class WorkflowForm extends Component {

  constructor(props){
    super(props);
    const segments = window.location.href.split('/').filter(segment => segment);
    const workflowId =  segments.pop();
    this.isNew = workflowId === "new";

    this.state = {
      workflowId: this.isNew ? null : workflowId,
      workflowObj: null,
      chatbots: [],
      error: null,
      activePaneIndex: 0,
      loading: this.isNew ? false : true
    }
  }

  componentDidMount() {
    if (!localStorage.getItem('apartix_session_id')) {
      window.location.href = `${window.location.origin}/login`
    } else {
      const { workflowId } = this.state;
      if (workflowId) {
        this.fetchWorkflow();
      } else {
        this.fetchChatbots();
      }
    }
  }

  updateActivePaneIndex = (newActiveIndex) => {
    this.setState({
      loading: true,
      activePaneIndex: newActiveIndex
    }, this.fetchWorkflow);
  }

  fetchChatbots = async () => {
    try {
      const response = await fetch(`https://${API_HOST}/telegram_chat_service/chat_bots`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('apartix_session_id')}` // Replace with your actual token or header value
        }
      }); // Replace with your API endpoint
      const result = await response.json();
      if (response.ok) {
        const data = result["data"].map((chatBotRecord) => {
          return new Chatbot(chatBotRecord)
        })
        this.setState({ chatbots: data, loading: false });
      } else {
        this.setState({ error: result, loading: false });
      }
    } catch (err) {
      this.setState({ error: err.message, loading: false });
    }
  };

  fetchWorkflow = async () => {
    const { workflowId, loading } = this.state;
    if (!loading) {
      this.setState({
        loading: true
      });
    }
    try {
      const response = await fetch(`https://${API_HOST}/workflow_service/workflows/${workflowId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('apartix_session_id')}` // Replace with your actual token or header value
        }
      }); // Replace with your API endpoint
      const result = await response.json();
      if (response.ok) {
        const { data } = result;
        console.log("workflow response data - ", data)
        const workflowObj = new Workflow(data["workflow"], data["status_tree"],
        data["workflow_variables"],
        data["workflow_level_actions"])
        const chatbots = data["chat_bots"].map((chatBotRecord) => {return new Chatbot(chatBotRecord)})

        this.setState({
          chatbots: chatbots,
          workflowObj: workflowObj,
          loading: false
        });
        console.log("Updating state")
      } else {
        this.setState({ error: result, loading: false });
      }
    } catch (err) {
      this.setState({ error: err.message, loading: false });
    }
  }

  panes = () => {
    const { workflowObj, chatbots } = this.state;
    if (this.isNew) {
      return [
        {
          menuItem: 'Workflow Initial Details',
          render: () => (
            <Tab.Pane>
              <WorkflowDetails fetchWorkflow={this.fetchWorkflow} workflowObj={workflowObj} chatbots={chatbots} updateActivePaneIndex={this.updateActivePaneIndex} />
            </Tab.Pane>
          )
        }
      ]
    }
    return ([
      {
        menuItem: 'Workflow Initial Details',
        render: () => (
          <Tab.Pane>
            <WorkflowDetails fetchWorkflow={this.fetchWorkflow} workflowObj={workflowObj} chatbots={chatbots} updateActivePaneIndex={this.updateActivePaneIndex} />
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Statuses',
        render: () => (
          <Tab.Pane>
            <Statuses fetchWorkflow={this.fetchWorkflow} workflowObj={workflowObj} updateActivePaneIndex={this.updateActivePaneIndex}/>
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Workflow Properties (optional)',
        render: () => (
          <Tab.Pane>
            <h3>Content for Tab 3</h3>
            <p>This is the content of the third tab.</p>
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Workflow Actions (optional)',
        render: () => (
          <Tab.Pane>
            <h3>Content for Tab 3</h3>
            <p>This is the content of the third tab.</p>
          </Tab.Pane>
        ),
      }
    ]
  )};

  handleTabChange = (e, { activeIndex }) => {
    this.setState({activePaneIndex: activeIndex });
  };

  render() {
    const { activePaneIndex, workflowObj, workflowId, loading } = this.state;
    const breadCrumbItems = [
      {label: "Workflow List", link: "/workflows"},
      {label: this.isNew ? "New" : workflowObj?.name()}
    ];
    return (
      <div className="workflow-form-container">
        <BreadCrumbs items={breadCrumbItems} />
        <h1>Workflow Details</h1>
        {loading ? <CLoader /> : (
          (workflowObj && workflowId) || !workflowId ? <Tab panes={this.panes()} activeIndex={activePaneIndex} onTabChange={this.handleTabChange}/> : ""
        )}
      </div>
    )
  }
}

export default WorkflowForm;
